<template>
  <v-toolbar
    ref="header"
    class="header-menu"
    :class="{
      'header-menu-open': openMenuDrawer,
      'header-menu-huygens': getAppName() == 'huygens',
      'header-menu-dordrecht5D': getAppName() == 'dordrecht5D',
      'header-menu-canals5D': getAppName() == 'canals5D'
    }"
    elevation="0"
    extended
  >
    <v-app-bar-nav-icon class="ml-2 nav-icon" @click="toggleMenu">
      <BaseIcon v-if="openMenuMain" icon="close" size="35px" padding="6px" />
      <BaseIcon
        v-else
        multiplatform
        icon="hamburger"
        size="35px"
        padding="6px"
      />
    </v-app-bar-nav-icon>

    <!-- Closed menu -->
    <template v-if="!openMenuDrawer">
      <v-spacer>
        <div class="text-center">
          <span>
            <div v-if="getAppName() == 'huygens'">
              <h2>HUYGENS’ TIJDMACHINE</h2>
            </div>

            <div v-if="getAppName() == 'dordrecht5D'">
              <h2>DORDRECHT5D</h2>
            </div>

            <div v-if="getAppName() == 'canals5D'">
              <h2>CANALS<span class="secondary-canals5D">5D</span></h2>
            </div>
          </span>
        </div>
      </v-spacer>
      <v-app-bar-nav-icon disabled class="mr-2">
        <BaseIcon multiplatform icon="logo" size="50px" />
      </v-app-bar-nav-icon>
    </template>

    <!-- Open menu -->
    <template v-else>
      <language-bar add-spacer />

      <v-app-bar-nav-icon class="mr-2 nav-icon invisible" disabled>
        <BaseIcon multiplatform icon="hamburger" size="35px" padding="6px" />
      </v-app-bar-nav-icon>
    </template>

    <!-- Menu items -->
    <template v-if="openMenuDrawer" #extension>
      <div v-if="openMenuMain" class="header-menu-content">
        <div class="header-menu-nav">
          <div
            v-for="navItem in getNavItems()"
            :key="navItem.url"
            class="header-menu-nav-item"
            @click.prevent="openMenuPage(navItem)"
          >
            <span class="header-menu-nav-title">
              <h2 :class="getAppName()">{{ navItem.title }}</h2>
            </span>
          </div>

          <!-- Logo -->
          <span v-if="$vuetify.breakpoint.height > 930">
            <div class="logo-container">
              <BaseIcon multiplatform icon="logo" size="120px" />
            </div>

            <div v-if="getAppName() == 'huygens'" class="mb-4">
              <h2>HUYGENS'</h2>
              <h2>TIJDMACHINE</h2>
            </div>

            <div v-if="getAppName() == 'dordrecht5D'" class="mb-4">
              <h2>DORDRECHT5D</h2>
            </div>

            <div v-if="getAppName() == 'canals5D'" class="mb-4">
              <h2>CANALS<span class="secondary-canals5D">5D</span></h2>
            </div>
          </span>
        </div>
      </div>

      <div class="w-100 mx-auto">
        <div v-if="openMenuItem" class="back-button-menu">
          <span @click="() => navigateMainMenu()">
            <BaseIcon icon="arrow-left" hover />
          </span>
        </div>

        <div v-if="openMenuItem" class="header-page" :class="getAppName()">
          <keep-alive>
            <component :is="menuItem" />
          </keep-alive>
        </div>
      </div>
    </template>
  </v-toolbar>
</template>

<script>
import { mapState } from "vuex";
import constants from "@/utils/constants";
import { appIdentifier } from "@/utils/appIdentifier.js";
import LanguageBar from "@/components/LanguageBar.vue";

export default {
  name: "HeaderMenu",
  components: {
    LanguageBar
  },
  data() {
    return {
      menuItem: null,
      openMenuMain: false,
      openMenuItem: null
    };
  },
  computed: {
    ...mapState({
      openMenuDrawer: state => state.openMenuDrawer
    })
  },
  methods: {
    getAppName() {
      return appIdentifier();
    },
    onOutsideClick(e) {
      // TODO fix double trigger when opening menu
      // Check if outside click is on a footer action icon
      if (e.target.id != "menu-icon" && this.openMenuDrawer) {
        this.toggleMenu();
      }
    },
    getNavItems() {
      if (appIdentifier() == constants.HUYGENS) {
        return [
          {
            title: this.$t("huygens.menu-item-1"),
            item: () => import("@/components/menus/pages/huygens/HowToUse.vue")
          },
          {
            title: this.$t("huygens.menu-item-2"),
            item: () => import("@/components/menus/pages/huygens/Huygens.vue")
          },
          {
            title: this.$t("huygens.menu-item-3"),
            item: () => import("@/components/menus/pages/huygens/WhatIs5D.vue")
          },
          {
            title: this.$t("huygens.menu-item-4"),
            item: () =>
              import("@/components/menus/pages/huygens/ExpertMode.vue")
          },
          {
            title: this.$t("huygens.menu-item-5"),
            item: () => import("@/components/menus/pages/huygens/SVS.vue")
          },
          {
            title: this.$t("huygens.menu-item-6"),
            item: () => import("@/components/menus/pages/huygens/Partners.vue")
          },
          {
            title: this.$t("huygens.menu-item-7"),
            item: () => import("@/components/menus/pages/huygens/Colofon.vue")
          },
          {
            title: this.$t("huygens.menu-item-8"),
            action: this.openFeaturedArticles
          }
        ];
      }

      if (appIdentifier() == constants.DORDRECHT5D) {
        return [
          {
            title: this.$t("dordrecht5D.menu-item-1"),
            item: () =>
              import("@/components/menus/pages/dordrecht5d/HowToUse.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-2"),
            item: () =>
              import("@/components/menus/pages/dordrecht5d/Dordrecht5d.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-3"),
            item: () =>
              import("@/components/menus/pages/dordrecht5d/WhatIs5D.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-4"),
            item: () =>
              import("@/components/menus/pages/dordrecht5d/ExpertMode.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-5"),
            item: () => import("@/components/menus/pages/dordrecht5d/SVS.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-6"),
            item: () =>
              import("@/components/menus/pages/dordrecht5d/Colofon.vue")
          },
          {
            title: this.$t("dordrecht5D.menu-item-7"),
            action: this.openFeaturedArticles
          }
        ];
      }

      if (appIdentifier() == constants.CANALS5D) {
        return [
          {
            title: this.$t("canals5D.menu-item-1"),
            item: () => import("@/components/menus/pages/canals5d/HowToUse.vue")
          },
          {
            title: this.$t("canals5D.menu-item-2"),
            item: () => import("@/components/menus/pages/canals5d/Canals5d.vue")
          },
          {
            title: this.$t("canals5D.menu-item-3"),
            item: () => import("@/components/menus/pages/canals5d/WhatIs5D.vue")
          },
          {
            title: this.$t("canals5D.menu-item-4"),
            item: () =>
              import("@/components/menus/pages/canals5d/ExpertMode.vue")
          },
          {
            title: this.$t("canals5D.menu-item-5"),
            item: () => import("@/components/menus/pages/canals5d/SVS.vue")
          },
          {
            title: this.$t("canals5D.menu-item-6"),
            item: () => import("@/components/menus/pages/canals5d/Currents.vue")
          },
          {
            title: this.$t("canals5D.menu-item-7"),
            item: () => import("@/components/menus/pages/canals5d/Partners.vue")
          },
          {
            title: this.$t("canals5D.menu-item-8"),
            item: () => import("@/components/menus/pages/canals5d/Colofon.vue")
          },
          {
            title: this.$t("canals5D.menu-item-9"),
            action: this.openFeaturedArticles
          }
        ];
      }
    },
    getMenuItem(navItem) {
      this.menuItem = navItem.item;
    },
    openMenuPage(navItem) {
      if (navItem.item) {
        this.openMenuMain = false;
        this.openMenuItem = navItem;
        this.getMenuItem(navItem);
      }

      navItem.action?.();
    },
    openFeaturedArticles() {
      this.toggleMenu();
      this.$store.commit(this.$mutations.SHOW_FEATURED_ARTICLES, true);
    },
    toggleMenu() {
      this.$store.commit(this.$mutations.TOGGLE_MENU_DRAWER);
      if (this.openMenuMain && !this.openMenuDrawer) {
        this.openMenuMain = null;
      } else {
        this.openMenuMain = true;
      }
      if (this.openMenuItem) {
        this.openMenuItem = null;
      }
    },
    navigateMainMenu() {
      this.openMenuItem = false;
      this.openMenuMain = true;
    }
  }
};
</script>

<style lang="scss">
.secondary {
  &-canals5D {
    color: $secondary-canals5D;
  }
}

.nav-icon {
  z-index: 100;
}

.back-button-menu {
  width: 660px;
  margin: 0 auto;
  height: 40px;
}

.header-page {
  position: relative;
  width: 675px;
  margin: 0 auto;
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;

  //Scrollbar Firefox
  scrollbar-width: thin;
  scrollbar-color: $white rgba($white, 0);

  /* Scrollbar Chrome/Edge/Safari */
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: rgba($white, 0) !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $white !important;
    border-radius: 20px;
  }

  &.huygens {
    border-top: 1px solid #bebb9b;

    a,
    .v-application a,
    .header-menu-huygens a {
      color: #bebb9b !important;
      text-decoration: underline;
    }

    span.accent-color {
      color: #e07a5f;
    }

    hr {
      border-bottom: 1px solid #bebb9b;
    }
  }

  &.dordrecht5D {
    border-top: 1px solid #e3b2b2;
  }

  &.canals5D {
    border-top: 1px solid rgba(33, 62, 82, 0.6);
  }
}

.header-menu {
  width: 95vw;
  height: 70px !important;
  border-bottom-left-radius: 45px !important;
  z-index: 10;
  position: absolute !important;
  right: 0 !important;

  &-huygens {
    background-color: rgba($primary-huygens, 0.9) !important;
  }

  &-dordrecht5D {
    background-color: rgba($primary-dordrecht5D, 0.9) !important;
  }

  &-canals5D {
    background-color: rgba($primary-canals5D, 0.95) !important;
  }

  .v-toolbar {
    &__extension {
      height: calc(100% - 70px) !important;
      width: 100%;
      margin: 0 auto;
      padding: 0;
    }
  }

  &-open {
    height: 88vh !important;
  }

  &-content {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .logo-container {
      display: flex;
      justify-content: center;
      margin: 50px 0 15px;
    }
  }

  &-nav {
    margin: 50px 0 5%;

    &-title {
      h2 {
        font-size: 1.8rem;

        &:hover {
          color: var(--v-hover-base) !important;
        }

        &.canals5D:hover {
          opacity: 0.6;
        }
      }
    }

    &-item {
      width: 100%;
      height: 100%;
      margin-bottom: 30px;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
